// Configure your import map in config/importmap.rb. Read more: https://github.com/rails/importmap-rails
import "./controllers"
import "@hotwired/turbo-rails"
// import * as bootstrap from "bootstrap"
import "chartkick"
import "alpinejs"
import "chartkick/chart.js"
